import { apiClient } from '@shared/api/api-client';
import type { ApiResponse, UserProfileResponse } from '@shared/types/api';

/**
 * API client for user profile operations.
 */
export const userApi = {
  /**
   * Get the authenticated user's profile information.
   */
  getProfile: async (): Promise<UserProfileResponse> => {
    const response = await apiClient.get<ApiResponse<UserProfileResponse>>("/users/profile");
    return response.data;
  },
};

export type { UserProfileResponse } from '@shared/types/api';
